// src/pages/Landing.js
import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ShoppingHeader = () => {
  const { t } = useTranslation();

  return (
    <main className="promotion-header" style={{ fontFamily: "'Hanuman', Arial, sans-serif" }}>
      <section className="shopping-header blog-perfume-header d-flex justify-content-center align-items-center">
        <Container
          fluid
          className="d-flex justify-content-center align-items-center"
        >
          <div className="d-flex flex-column justify-content-center align-items-center mt-5 mt-md-0">
            <span className="text-white fs-5 mt-5 mt-md-0">{t("Home / Blogs")}</span>
            <h1 className="mt-2 text-white fs-custom">{t("BLOGS")}</h1>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default ShoppingHeader;

//correct with 25
